import {useEffect, useState} from 'react'
import {Icon} from 'src/common/Icon'
import {PREP_MESSAGES, skl} from './constants'

export function EmptyState() {
  const [msgIndex, setMsgIndex] = useState(0)

  // Cycle through preparation messages while the form is empty
  useEffect(() => {
    const timer = setInterval(() => setMsgIndex((i) => (i + 1) % PREP_MESSAGES.length), 2800)
    return () => clearInterval(timer)
  }, [])

  return (
    <div
      style={{
        padding: '48px 24px 56px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 500,
      }}
    >
      <div
        className="mx-auto mb-7 flex size-16 animate-epg-prep-pulse items-center justify-center rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(180,255,68,0.25) 0%, rgba(180,255,68,0.05) 60%, transparent 70%)',
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(180,255,68,0.5) 0%, rgba(180,255,68,0.15) 70%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon name="sparkle" className="size-3.5" />
        </div>
      </div>

      <div key={msgIndex} className="min-h-5 animate-epg-msg-fade-28 text-[14px] font-medium text-black/55">
        {PREP_MESSAGES[msgIndex]}
      </div>

      <div style={{fontSize: 12, color: 'rgba(0,0,0,0.30)', marginTop: 12, lineHeight: 1.5}}>
        Fill in the details on the left and we'll do the rest
      </div>

      <div style={{maxWidth: 400, margin: '32px auto 0', opacity: 0.4}}>
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 0',
              borderBottom: i < 3 ? '1px solid rgba(0,0,0,0.04)' : 0,
            }}
          >
            <div className={skl} style={{width: 80 + i * 20, height: 10}} />
            <div className={skl} style={{width: 50, height: 8}} />
          </div>
        ))}
      </div>
    </div>
  )
}
